import React, { useState, useEffect } from "react";
import {
  Document,
  Page,
  Text,
  View,
  StyleSheet,
  Image,
} from "@react-pdf/renderer";
import { Font } from "@react-pdf/renderer";
import fontBold from "./fonts/NotoSansTamil-Bold.ttf";
import fontRegular from "./fonts/NotoSansTamil-Regular.ttf";
import { BsTransparency } from "react-icons/bs";

const formatDate = (dateString) => {
  const date = new Date(dateString);

  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();

  return `${day}-${month}-${year}`;
};

Font.register({
  family: "fontBold",
  fonts: [{ src: fontBold, fontStyle: "normal", fontWeight: "bold" }],
});
Font.register({
  family: "fontRegular",
  fonts: [{ src: fontRegular, fontStyle: "normal", fontWeight: "normal" }],
});

const styles = StyleSheet.create({
  normalText: {
    fontFamily: "fontRegular",
    fontWeight: "normal",
  },
  boldText: {
    fontFamily: "fontBold",
    fontWeight: "bold",
    marginTop: 3,
  },
  page: {
    flexDirection: "column",
    backgroundColor: "#fff",
    padding: 0,
  },
  imageContainer: {
    flexDirection: "column",
    padding: 10,
    alignItems: "center",
    width: "100%",
  },
  imageRow: {
    flexDirection: "row",
    justifyContent: "center",
    width: "100%",
    marginBottom: 5, // Space between rows
  },
  // imageWrapper: {
  //   width: "45%",
  //   height: 120,
  //   marginHorizontal: 5,
  //   justifyContent: "center",
  //   alignItems: "center",
  // },
  // proofImage: {
  //   width: 120,
  //   height: 120,
  //   objectFit: "contain",
  // },
  emptyImagePlaceholder: {
    width: 120,
    height: 120,
    borderWidth: 1,
    borderColor: "#4535C1",
    backgroundColor: "#f0f0f0",
  },

  header: {
    fontFamily: "fontRegular",
    fontSize: 8,
  },
  section: {
    margin: 15,
    flexGrow: 1,
    border: 1,
    padding: 0,
    letterSpacing: 1,
    borderColor: "#4535C1",
    color: "#4535C1",
  },
  dupe: {
    margin: 15,
    flexGrow: 1,
    border: 1,
    padding: 0,
    borderColor: "#4535C1",
    letterSpacing: 1,
    color: "#4535C1",
  },
  godtitle: {
    fontSize: 8,
    padding: 5,
    textAlign: "center",
  },
  godtitles: {
    position: "absolute",
    justifyContent: "start",
    alignItems: "start",
    textAlign: "start",
    right: 140,
    bottom: 50,
    top: 1,
    left: 300,
    padding: 10,
    color: "#4535C1",
    fontSize: 70,
    fontWeight: "bold",
  },
  font: {
    fontFamily: "fontRegular",
  },
  red: {
    color: "red",
  },
  storename: {
    textAlign: "center",
    fontFamily: "fontBold",
    fontSize: 20,
    letterSpacing: 1,
    fontWeight: "bold",
  },
  table: {
    display: "table",
    fontFamily: "fontRegular",
    flexDirection: "row",
    width: "100%",
    borderBottom: 1,
    borderTop: 1,
    fontSize: 9,
    borderColor: "#4535C1",
  },
  border_bottom: {
    width: "100%",
    borderTop: 1,
    borderColor: "#4535C1",
  },
  tableRow: {
    flexDirection: "row",
    marginTop: 20,
    marginLeft: 40,
    justifyContent: "space-between",
  },
  tableRow1: {
    flexDirection: "row",
    paddingLeft: "90px",
  },
  table2: {
    marginVertical: 10,
    borderWidth: 0.5,
    borderColor: "#4535C1",
    width: "100%",
    marginTop: 50,
  },
  tableRow2: {
    flexDirection: "row",
    width: "100%",
  },
  tableCell2: {
    borderRightWidth: 0.5,
    borderBottomWidth: 0.5,
    borderColor: "#4535C1",
    textAlign: "center",
    padding: 5,
    fontSize: 8.5,
    flex: 1,
  },
  company: {
    width: "50%",
    padding: 6,
    fontFamily: "fontRegular",
    textAlign: "center",
    fontSize: 9,
  },
  tableCell: {
    width: "30%",
    padding: 7,
    fontSize: 8.5,
  },

  dateCell: {
    width: "50%",
    padding: 7,
    fontSize: 8.5,
  },
  pad: {
    paddingVertical: 0.5,
  },
  tab: {
    display: "table",
    fontFamily: "fontRegular",
    flexDirection: "row",
    paddingHorizontal: 10,
    paddingVertical: 10,
    fontSize: 8,
  },
  pawnAmt: {
    textAlign: "right",
  },
  customerdetail: {
    paddingHorizontal: 7,
    //display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    padding: 10,
    fontSize: 7.5,
  },
  details1: {
    paddingVertical: 6,
    display: "flex",
    flexDirection: "row",
  },
  details: {
    paddingVertical: 6,
    flexDirection: "row",
  },
  details2: {
    flexDirection: "row",
    fontSize: 7.6,
  },
  state: {
    width: "28%",
    fontFamily: "fontBold",
    fontWeight: "bold",
  },
  customtab: {
    display: "flex",
    fontFamily: "fontRegular",
    flexDirection: "row",
    paddingVertical: 4,
  },
  jewelprice: {
    paddingVertical: 10,
  },
  row: {
    flexDirection: "row",
    marginBottom: 5,
  },
  footer: {
    display: "table",
    fontFamily: "fontRegular",
    flexDirection: "row",
    padding: 6,
    paddingTop: 50,
    color: "#4535C1",
  },
  time: {
    width: "30%",
    padding: 5,
    border: 1,
    marginHorizontal: 1,
    borderRadius: 8,
    fontSize: 8,
    borderColor: "#4535C1",
  },
  footerdesc: {
    padding: 12,
    border: 1,
    marginHorizontal: 3,
    borderRadius: 8,
    fontSize: 8,
    paddingHorizontal: 10,
    width: "70%",
    borderColor: "#4535C1",
  },
  origialdesc: {
    width: "100%",
    padding: 12,
    border: 1,
    marginHorizontal: 2,
    borderRadius: 8,
    fontSize: 8,
    borderColor: "#4535C1",
  },
  phone: {
    width: "30%",
    padding: 8,
    border: 1,
    margin: "0 auto",
    marginHorizontal: 2,
    fontSize: 8,
    fontFamily: "fontRegular",
    borderRadius: 8,
    borderColor: "#4535C1",
  },
  ph: {
    marginVertical: 10,
  },
  none: {
    display: "none",
  },
  line: {
    textDecorationLine: "underline",
    textDecorationStyle: "solid",
    color: "#4535C1",
    marginTop: 0,
  },
  termsTitle: {
    fontSize: 10,
    fontFamily: "fontRegular",
  },
  termlist: {
    fontSize: 9,
    paddingHorizontal: 22,
  },
  termpoint: {
    paddingVertical: 4,
  },
  billcreate: {
    fontSize: 8,
  },
  padmac: {
    position: "absolute",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
    right: 40,
    bottom: 15,
    padding: 10 ,
    fontSize: 12,
    fontWeight: "bold",
  },
  paidStamp: {
    position: "absolute",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
    right: 15,
    bottom: 50,
    padding: 10,
    borderWidth: 2,
    borderColor: "#4535C1",
    borderRadius: 5,
    color: "#4535C1",
    fontSize: 20,
    fontWeight: "bold",
  },
  paidText: {
    color: "#4535C1",
    fontSize: 20,
    fontWeight: "bold",
  },
  divider: {
    width: "100%",
    height: 1.5,
    backgroundColor: "#4535C1",
    marginVertical: 5,
  },
  dateText: {
    color: "#C40C0C",
    fontSize: 14,
    fontWeight: "bold",
  },
  tableContent: {
    marginVertical: "550px",
    margin: 8,
    flexGrow: 1,
    border: 1,
    padding: 0,
    letterSpacing: 1,
    borderColor: "#4535C1",
  },
  boldTextone: {
    fontFamily: "fontBold",
    fontWeight: "bold",
    fontSize: 18,
    marginTop: 3,
  },
  headright: {
    paddingLeft: 30,
  },
  headdivright: {
    fontSize: 13,
    paddingLeft: -15,
  },
  container: {
    marginVertical: 1,
    alignItems: "center",
  },
  // dueDate: {
  //   fontSize: 7,
  //   fontWeight: 'bold'
  // },
  // line: {
  //   fontSize: 7,
  //   marginVertical: 1
  // },
  // amount: {
  //   fontSize: 7,
  //   letterSpacing: 2,
  //   fontWeight: '600'
  // },
  mainContainer: {
    flexDirection: "row",
    justifyContent: "space-between",
    width: "100%",
    padding: 10,
  },

  leftSection: {
    width: "48%",
    paddingRight: 10,
  },

  verticalDivider: {
    width: 1,
    backgroundColor: "#4535C1",
    marginHorizontal: 4,
    height: "100%",
  },

  rightSection: {
    width: "48%",
    alignItems: "center",
    justifyContent: "flex-start",
  },

  detailsRow: {
    flexDirection: "row",
    justifyContent: "flex-start",
    marginBottom: 10,
    fontSize: 7.5,
  },

  label: {
    width: "45%",
    fontWeight: "bold",
    fontFamily: "fontBold",
  },

  value: {
    width: "55%",
  },

  amountBlock: {
    alignItems: "flex-start",
    justifyContent: "flex-start",
  },

  dueDate: {
    fontSize: 7.5,
    fontWeight: "bold",
  },

  line: {
    fontSize: 7.5,
    marginVertical: 1,
  },

  amount: {
    fontSize: 7.5,
    fontWeight: "bold",
  },

  imageWrapper: {
    width: 120,
    height: 120,
    marginVertical: 5,
    justifyContent: "center",
    alignItems: "center",
  },

  proofImage: {
    width: 120,
    height: 120,
    objectFit: "contain",
    borderWidth: 1,
     borderColor: "#4535C1",
  },
  logo: {
    width: 150,
    height: 75,
    marginBottom: 20,
    paddingLeft: 20,
  },
  boldha: {
    fontWeight: "extrabold",
    fontSize: 10,
    paddingTop: -25,
    paddingLeft: 7,
  },
  paragragh: {
    fontSize: 9,
    paddingLeft: -170,
  },
  kuruvi: {
    fontsize:9,
  }
});

const JewelPawnPdf = ({ data }) => {
  console.log("pdfdata", data);
  const formattedDate = formatDate(data.pawnjewelry_date);
  const calculateDueDate = (pawnDateStr, period) => {
    const [day, month, year] = pawnDateStr.split("-").map(Number);
    const startDate = new Date(year, month - 1, day);

    const monthsToAdd = parseInt(period);
    const dueDate = new Date(startDate);
    dueDate.setMonth(startDate.getMonth() + monthsToAdd);

    return formatDate(dueDate);
  };
  console.log("paidby", data.paidby);
  const interestPeriod = data.Jewelry_recovery_agreed_period;
  const monthsOnly = parseInt(interestPeriod);
  console.log(monthsOnly);

  const principaldueDate = calculateDueDate(formattedDate, monthsOnly);

  const Monthyinterest =
    data.original_amount * parseInt(data.interest_rate) / 100;
  const Totalinterest = Monthyinterest * monthsOnly;

  const tableHeaders = [
    "வட்டி ",
    "1 மாத வட்டி",
    "ஆபரணங்கள்",
    "எடை",
    "கல் எடை",
    "நிகர எடை",
  ];

  const tableData = [
    [data.interest_rate,Monthyinterest, data.pledged_items, data.jewel_weight, data.net_weight,data.total_weight],
  ];

  return (
    <Document>
      <Page size="A4" orientation="portrait" style={styles.page}>
        <View style={styles.dupe}>
          <View style={styles.font}>
            <View style={styles.table}>
              <View style={styles.tableCell}>
                <Text style={styles.pad}>
                  <Text style={styles.boldText}>License No:</Text>
                  <Text style={styles.normalText}>BPL NO: 06/2017-2018</Text>
                </Text>
                <Image
                  style={styles.logo}
                  src="/logo192.png" 
                />
              </View>
              <View style={styles.tableRow}>
                <View style={styles.company}>
                  <Text style={styles.storename}>செல்லம் பைனான்ஸ் 
                  </Text>
                  <Text style={{marginTop:3}}>
                  358-1 வடக்கு மாசி வீதி, மதுரை-625001 
                  </Text>
                  <Text style={styles.boldText}>
                    (கடை வேலை நேரம்  9:00 AM to 6:00 PM (திங்கள்  to
                    சனிக்கிழமை வரை  ))
                  </Text>
                  <Text style={styles.boldTextone}>அடகு ரசீது </Text>
                  <Text style={styles.kuruvi}>எங்களிடம் தங்கம்,வெள்ளி நகைகள் 
அனைத்தும்  நல்ல  விலைக்கு வாங்க,விற்க 
அணுகவும் .</Text> 
                </View>
              </View>
              <View style={styles.tableRow1}>
                <View style={styles.dateCell}>
                  <View style={styles.headdivright}>
                    <Text>Ph : 98421 84070 </Text>
                    <Text style={styles.headright}>9042222080 </Text>
                  </View>
                </View>
              </View>
            </View>
            <View style={styles.mainContainer}>
              <View style={styles.leftSection}>
                <View style={styles.detailsRow}>
                  <Text style={styles.label}>1.அடகு தேதி  : </Text>
                  <Text style={styles.value}> {formattedDate} </Text>
                </View>
                <View style={styles.detailsRow}>
                  <Text style={styles.label}>2.அடகு எண்  : </Text>
                  <Text style={styles.value}> {data.receipt_no} </Text>
                </View>
                <View style={styles.detailsRow}>
                  <Text style={styles.label}>3.வாடிக்கையாளர் எண்  :</Text>
                  <Text style={styles.value}> {data.customer_no} </Text>
                </View>
                <View style={styles.detailsRow}>
                  <Text style={styles.label}>4.வாடிக்கையாளர் பெயர்  :</Text>
                  <Text style={styles.value}> {data.name} </Text>
                </View>{" "}
                <View style={styles.detailsRow}>
                  <Text style={styles.label}>5.வாடிக்கையாளர் முகவரி :</Text>
                  <Text style={styles.value}>
                    {data.customer_details
                      .split(",")
                      .map((part) => part.trim())
                      .join(",\n")}
                  </Text>
                </View>
                <View style={styles.detailsRow}>
                  <Text style={styles.label}>6.போன் நம்பர்  :</Text>
                  <Text style={styles.value}> {data.mobile_number} </Text>
                </View>
                <View style={styles.detailsRow}>
                  <Text style={styles.label}>7.ஆதார் நம்பர்   :</Text>
                  <Text style={styles.value}> {data.mobile_number} </Text>
                </View>
                <View style={styles.detailsRow}>
                  <Text style={styles.label}>8.கடன் தொகை :</Text>
                  <Text style={styles.value}> {data.original_amount} </Text>
                </View>
                <View style={styles.detailsRow}>
                  <Text style={styles.label}>8.கடன் காலம் :</Text>
                  <Text style={styles.value}>
                    {" "}
                    {data.Jewelry_recovery_agreed_period}
                  </Text>
                </View>
                <View style={styles.detailsRow}>
                  <Text style={styles.label}>9.அசல் தவணை தேதி :</Text>
                  <View style={styles.amountBlock}>
                    <Text style={styles.dueDate}>{principaldueDate}</Text>
                    <Text style={styles.line}>____________</Text>
                    <Text style={styles.amount}>{data.original_amount}</Text>
                  </View>
                </View>
                <View style={styles.detailsRow}>
                  <Text style={styles.label}>10.வட்டி செலுத்த வேண்டிய தேதி :</Text>
                  <View style={styles.amountBlock}>
                    <Text style={styles.dueDate}>{principaldueDate}</Text>
                    <Text style={styles.line}>____________</Text>
                    <Text style={styles.amount}>{Totalinterest}</Text>
                  </View>
                </View>
              </View>
              <View style={styles.verticalDivider} />
            
                <View style={styles.rightSection}>
                  <View style={styles.imageRow}>
                    {[...Array(1)].map((_, index) => (
                      <View key={`top-${index}`} style={styles.imageWrapper}>
                         {data.proof_base64code[index] ? (
                          <Image
                            style={styles.proofImage}
                            src={data.proof_base64code[index]}
                          />
                        ) : (
                          <View style={styles.emptyImagePlaceholder} />
                         )} 
                      </View>
                    ))}
                  </View>
                  <View style={styles.imageRow}>
                    {[...Array(1)].map((_, index) => (
                      <View key={`bottom-${index}`} style={styles.imageWrapper}>
                         {data.proof_base64code[index + 1] ? (
                          <Image
                            style={styles.proofImage}
                            src={data.proof_base64code[index + 1]}
                          />
                        ) : (
                          <View style={styles.emptyImagePlaceholder} />
                         )} 
                      </View>
                    ))}
                  </View>
                </View>
              
            </View>
            <View style={styles.table2}>
              <View style={styles.tableRow2}>
                {tableHeaders.map((header, idx) => (
                  <Text key={`header-${idx}`} style={styles.tableCell2}>
                    {header}
                  </Text>
                ))}
              </View>
              {tableData.map((row, rowIndex) => (
                <View key={`row-${rowIndex}`} style={styles.tableRow2}>
                  {row.map((cell, cellIndex) => (
                    <Text
                      key={`cell-${rowIndex}-${cellIndex}`}
                      style={styles.tableCell2}
                    >
                      {cell}
                    </Text>
                  ))}
                </View>
              ))}
            </View>

            <View
              style={{
                flexDirection: "row",
                justifyContent: "space-between",
                paddingTop: 100,
                paddingHorizontal: 20,
              }}
            >
              <Text style={{ fontSize: 9, fontFamily: "fontBold" }}>
                Sign (வாடிக்கையாளர்)
              </Text>
              <Text style={{ fontSize: 9, fontFamily: "fontBold" }}>
                Sign (செல்லம் பைனான்ஸ் )
              </Text>
            </View>
            <View style={{ flexDirection: "row", paddingTop: 50 }}>
              <View>
                <Text style={[styles.boldha,styles.boldText]}>விதிமுறைகள் மற்றும் நிபந்தனைகள்:</Text>
              </View>
              <Text style={styles.paragragh}>
                அடகு வைத்த நகைகளைத் திருப்ப  வரும் போதும்  அல்லது வட்டியுடன் கடனைப் புதுப்பிக்கும்போது <br></br> இந்த ரசீதைக் கொண்டு வருவதை உறுதிப்படுத்திக் கொள்ளுங்கள்
              </Text>
            </View>
          </View>
        </View>
      </Page>
    </Document>
  );
};

export default JewelPawnPdf;
